import { AppState } from "store";
import { GroupsFiltersArgs } from "./types";

export const groupsFiltersSelector = ({
  filters,
}: AppState): GroupsFiltersArgs => {
  return filters.groups;
};
